import { defineStore } from 'pinia';

export const useNavigationStore = defineStore('UseNavigationStore', () => {
	const isHeaderVisible = shallowRef<boolean>(false);
	// Mobile
	const isMobileMenuOpen = shallowRef<boolean>(false);
	const isMobileProfileMenuOpen = shallowRef<boolean>(false);
	// Desktop
	const isNavigationMenuOpen = shallowRef(false);
	const isProfileNavigationMenuOpen = shallowRef(false);

	function setIsHeaderVisible(value: boolean) {
		isHeaderVisible.value = value;
	}

	function setIsMobileMenuOpen(value: boolean) {
		isMobileMenuOpen.value = value;
	}

	function setIsMobileProfileMenuOpen(value: boolean) {
		isMobileProfileMenuOpen.value = value;
	}

	function setIsNavigationMenuOpen(value: boolean) {
		isNavigationMenuOpen.value = value;
	}

	function setIsProfileNavigationMenuOpen(value: boolean) {
		isProfileNavigationMenuOpen.value = value;
	}

	function closeMenus() {
		setIsMobileMenuOpen(false);
		setIsMobileProfileMenuOpen(false);
	}

	const isMenuMobileOpen = computed(
		() => isMobileMenuOpen.value || isMobileProfileMenuOpen.value
	);

	const isMenuOpen = computed(
		() =>
			isNavigationMenuOpen.value ||
			isProfileNavigationMenuOpen.value ||
			isMenuMobileOpen.value
	);

	return {
		isHeaderVisible,
		setIsHeaderVisible,
		isMobileMenuOpen,
		isMobileProfileMenuOpen,
		isNavigationMenuOpen,
		isProfileNavigationMenuOpen,
		isMenuMobileOpen,
		isMenuOpen,
		setIsMobileMenuOpen,
		setIsMobileProfileMenuOpen,
		setIsNavigationMenuOpen,
		setIsProfileNavigationMenuOpen,
		closeMenus
	};
});
